import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'

import api from '@/api/api'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import FileField from '@/components/general/fields/file/file'

export default {
  name: 'sellers-list',
  data () {
    return {
      sellers: [],
      menuOptions: [
        {
          iconClass: 'fa fa-pencil',
          name: this.$t('private.sellers.list.menu_more_options.edit_seller'),
          action: 'edit'
        },
        {
          iconClass: 'fa fa-trash',
          name: this.$t('private.sellers.list.menu_more_options.delete_seller'),
          action: 'delete'
        }
      ],
      filters: {
        fullname: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.sellers.list.filters.fullname'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        username: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.sellers.list.filters.username'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        email: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.sellers.list.filters.email'),
          type: 'email',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        ascending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.sellers.list.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.sellers.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.firstname'),
            value: 'firstname'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.lastname'),
            value: 'lastname'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.sellers.list.filters.sort_options.created_at'),
          value: 'createdAt',
          name: this.$t('private.sellers.list.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.sellers.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.firstname'),
            value: 'firstname'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.lastname'),
            value: 'lastname'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.sellers.list.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.sellers.list.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.sellers.list.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.sellers.list.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.sellers.list.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.sellers.list.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '10px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      getSellersActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      formCreate: {
        fields: {
          firstname: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.firstname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          lastname: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.lastname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          username: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.username'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 4,
              maxLength: 100,
              required: true
            }
          },
          email: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          password: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.password'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          delegation: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.delegation'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          sellerType: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.seller_type'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          active: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
            value: true,
            name: this.$t('private.sellers.list.fields.active'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          multiType: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
            value: false,
            name: this.$t('private.sellers.list.fields.multi_type'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          permissions: {
            id: _.uniqueId('field_'),
            display: true,
            name: this.$t('private.sellers.list.fields.permissions'),
            error: false,
            value: {
              sellers: false,
              clients: false,
              contracts: false,
              reports: false,
              masterData: false
            },
            options: {
              sellers: {
                name: this.$t('private.sellers.list.fields.permissions_options.sellers'),
                value: false
              },
              clients: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients'),
                value: false
              },
              clientsRecords: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients_records'),
                value: false
              },
              contracts: {
                name: this.$t('private.sellers.list.fields.permissions_options.contracts'),
                value: false
              },
              reports: {
                name: this.$t('private.sellers.list.fields.permissions_options.reports'),
                value: false
              },
              masterData: {
                name: this.$t('private.sellers.list.fields.permissions_options.master_data'),
                value: false
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['sellers', 'clients', 'clientsRecords', 'contracts', 'reports', 'masterData']
            }
          }
        },
        active: false
      },
      displayCreateSeller: false,
      formUpdate: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          firstname: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.firstname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          lastname: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.lastname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          username: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.username'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 4,
              maxLength: 100,
              required: true
            }
          },
          email: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          password: {
            id: _.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.password'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 100
            }
          },
          delegation: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.delegation'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          sellerType: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.seller_type'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          active: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.active'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          multiType: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
            value: false,
            name: this.$t('private.sellers.list.fields.multi_type'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          permissions: {
            id: _.uniqueId('field_'),
            display: true,
            name: this.$t('private.sellers.list.fields.permissions'),
            error: false,
            value: {
              sellers: false,
              clients: false,
              contracts: false,
              reports: false,
              masterData: false
            },
            options: {
              sellers: {
                name: this.$t('private.sellers.list.fields.permissions_options.sellers'),
                value: false
              },
              clients: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients'),
                value: false
              },
              clientsRecords: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients_records'),
                value: false
              },
              contracts: {
                name: this.$t('private.sellers.list.fields.permissions_options.contracts'),
                value: false
              },
              reports: {
                name: this.$t('private.sellers.list.fields.permissions_options.reports'),
                value: false
              },
              masterData: {
                name: this.$t('private.sellers.list.fields.permissions_options.master_data'),
                value: false
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['sellers', 'clients', 'clientsRecords', 'contracts', 'reports', 'masterData']
            }
          }
        },
        active: false
      },
      migrateUsersWindow: {
        display: false,
        migrateCSVFileActive: false,
        sellersToCreated: [],
        sellersWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ',',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      displayUpdateSeller: false,
      getDelegationsActive: false,
      getSellersTypesActive: false,
      exportUsersActive: false,
      displayFoo: false
    }
  },
  methods: {
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    getSellers () {
      let vm = this

      vm.getSellersActive = true
      vm.sellers = []

      let dataToSend =
        '/?fullname=' + vm.filters.fullname.value +
        '&username=' + vm.filters.username.value +
        '&email=' + vm.filters.email.value +
        '&ascending=' + vm.filters.ascending.value +
        '&descending=' + vm.filters.descending.value +
        '&limit=' + (vm.filters.limit.value + 1) +
        '&skip=' + vm.filters.skip.value

      api
        .sellers
        .getSellers(dataToSend)
        .then((response) => {
          vm.getSellersActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.sellers = response.data.sellers

          if (vm.sellers.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.sellers.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.sellers.pop()
          } else {
            vm.nextPage = false
          }
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getSellers()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getSellers()
      }
    },
    optionSelected (data) {
      let vm = this

      if (data.action == 'edit') {
        vm.formUpdate.fields.id.value = data.element.id
        vm.formUpdate.fields.firstname.value = data.element.firstname
        vm.formUpdate.fields.lastname.value = data.element.lastname
        vm.formUpdate.fields.username.value = data.element.username
        vm.formUpdate.fields.email.value = data.element.email
        vm.formUpdate.fields.password.value = ''
        vm.formUpdate.fields.delegation.fakeValue = data.element.delegation ? data.element.delegation.name : ''
        vm.formUpdate.fields.delegation.value = data.element.delegation ? data.element.delegation.objectId : ''
        vm.formUpdate.fields.sellerType.fakeValue = data.element.sellerType ? data.element.sellerType.name : ''
        vm.formUpdate.fields.sellerType.value = data.element.sellerType ? data.element.sellerType.objectId : ''
        vm.formUpdate.fields.active.value = !!data.element.active
        vm.formUpdate.fields.active.fakeValue = data.element.active ? vm.$t('private.sellers.list.fields.active_options.yes') : vm.$t('private.sellers.list.fields.active_options.no')
        vm.formUpdate.fields.multiType.value = !!data.element.multi_type
        vm.formUpdate.fields.multiType.fakeValue = data.element.multi_type ? vm.$t('private.sellers.list.fields.active_options.yes') : vm.$t('private.sellers.list.fields.active_options.no')
        vm.formUpdate.fields.permissions.value = data.element.permissions ? data.element.permissions : vm.formCreate.fields.permissions.value

        vm.displayUpdateSeller = true
      } else if (data.action == 'delete') {
        vm.deleteSeller(data.element)
      }
    },
    formCreateSubmit () {
      let vm = this

      if (vm.formCreate.active) {
        return
      }

      vm.formCreate.active = true

      vm.$root.$emit('validate', [vm.formCreate.fields, (response) => {
        if (!response.success) {
          vm.formCreate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          firstname: vm.formCreate.fields.firstname.value,
          lastname: vm.formCreate.fields.lastname.value,
          username: vm.formCreate.fields.username.value,
          email: vm.formCreate.fields.email.value,
          password: vm.formCreate.fields.password.value,
          delegation: vm.formCreate.fields.delegation.value,
          sellerType: vm.formCreate.fields.sellerType.value,
          active: vm.formCreate.fields.active.value,
          multiType: vm.formCreate.fields.multiType.value,
          permissions: vm.formCreate.fields.permissions.value
        }

        api
          .sellers
          .createSeller(dataToSend)
          .then((response) => {
            vm.formCreate.active = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                let message = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (response.data.error.code == 202) {
                let message = {
                  message: [vm.$t('errors.custom.017')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (response.data.error.code == 203) {
                let message = {
                  message: [vm.$t('errors.custom.009')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              return
            }

            let message = {
              message: [vm.$t('private.sellers.list.create_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getSellers()

            vm.displayCreateSeller = false

            vm.formCreate.fields.firstname.value = ''
            vm.formCreate.fields.lastname.value = ''
            vm.formCreate.fields.username.value = ''
            vm.formCreate.fields.email.value = ''
            vm.formCreate.fields.password.value = ''
            vm.formCreate.fields.delegation.fakeValue = ''
            vm.formCreate.fields.delegation.value = ''
            vm.formCreate.fields.sellerType.fakeValue = ''
            vm.formCreate.fields.sellerType.value = ''
            vm.formCreate.fields.active.value = ''
            vm.formCreate.fields.active.fakeValue = ''
            vm.formCreate.fields.multiType.value = ''
            vm.formCreate.fields.multiType.fakeValue = ''

            for (var i in vm.formCreate.fields.permissions.value) {
              vm.formCreate.fields.permissions.value[i] = false
            }
          })
      }])
    },
    formUpdateSubmit () {
      let vm = this

      if (vm.formUpdate.active) {
        return
      }

      vm.formUpdate.active = true

      vm.$root.$emit('validate', [vm.formUpdate.fields, (response) => {
        if (!response.success) {
          vm.formUpdate.active = false

          response.type = 'error'

          response.field.error = true

          let dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          }

          ScrollTo.submit(dataToScroll)

          vm.$root.$emit('showMessage', response)

          return
        }

        let dataToSend = {
          id: vm.formUpdate.fields.id.value,
          firstname: vm.formUpdate.fields.firstname.value,
          lastname: vm.formUpdate.fields.lastname.value,
          username: vm.formUpdate.fields.username.value,
          email: vm.formUpdate.fields.email.value,
          password: vm.formUpdate.fields.password.value,
          delegation: vm.formUpdate.fields.delegation.value,
          sellerType: vm.formUpdate.fields.sellerType.value,
          active: vm.formUpdate.fields.active.value,
          multiType: vm.formUpdate.fields.multiType.value,
          permissions: vm.formUpdate.fields.permissions.value
        }

        api
          .sellers
          .updateSeller(dataToSend)
          .then((response) => {
            vm.formUpdate.active = false

            if (response.status != 200) {
              let message = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              }

              vm.$root.$emit('showMessage', message)

              return
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                let message = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              if (response.data.error.code == 202 || response.data.error.code == '017') {
                let message = {
                  message: [vm.$t('errors.custom.017')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (response.data.error.code == 203 || response.data.error.code == '009') {
                let message = {
                  message: [vm.$t('errors.custom.009')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)
              }

              return
            }

            let message = {
              message: [vm.$t('private.sellers.list.update_success')],
              type: 'success'
            }

            vm.$root.$emit('showMessage', message)

            vm.getSellers()

            vm.displayUpdateSeller = false

            vm.formUpdate.fields.id.value = ''
            vm.formUpdate.fields.firstname.value = ''
            vm.formUpdate.fields.lastname.value = ''
            vm.formUpdate.fields.username.value = ''
            vm.formUpdate.fields.email.value = ''
            vm.formUpdate.fields.password.value = ''
            vm.formUpdate.fields.delegation.fakeValue = ''
            vm.formUpdate.fields.delegation.value = ''
            vm.formUpdate.fields.sellerType.fakeValue = ''
            vm.formUpdate.fields.sellerType.value = ''
            vm.formUpdate.fields.active.value = ''
            vm.formUpdate.fields.active.fakeValue = ''
            vm.formUpdate.fields.multiType.value = ''
            vm.formUpdate.fields.multiType.fakeValue = ''

            for (var i in vm.formUpdate.fields.permissions.value) {
              vm.formUpdate.fields.permissions.value[i] = false
            }
          })
      }])
    },
    deleteSeller (element) {
      let vm = this

      let questionModal = {
        title: this.$t('private.sellers.list.question_modal.title'),
        question: this.$t('private.sellers.list.question_modal.question')
      }

      vm.$root.$emit('question-modal', [questionModal, (response) => {
        if (response) {
          let dataToSend = '/?id=' + element.id

          api
            .sellers
            .deleteSeller(dataToSend)
            .then((response) => {
              vm.formUpdate.active = false

              if (response.status != 200) {
                let message = {
                  message: [vm.$t('errors.custom.001')],
                  type: 'error'
                }

                vm.$root.$emit('showMessage', message)

                return
              }

              if (!response.data.success) {
                if (response.data.error.code == 101) {
                  let message = {
                    message: [vm.$t('errors.parse.101')],
                    type: 'error'
                  }

                  vm.$root.$emit('showMessage', message)
                }

                return
              }

              let message = {
                message: [vm.$t('private.sellers.list.delete_success')],
                type: 'success'
              }

              vm.$root.$emit('showMessage', message)

              vm.getSellers()
            })
        }
      }])
    },
    getDelegations () {
      let vm = this

      vm.getDelegationsActive = true

      let dataToSend = ''

      api
        .delegations
        .getDelegations(dataToSend)
        .then((response) => {
          vm.getDelegationsActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let delegations = response.data.delegations

          delegations = _.map(delegations, (delegation) => {
            return {
              fakeValue: delegation.name,
              value: delegation.id
            }
          })

          vm.formCreate.fields.delegation.options = delegations
          vm.formUpdate.fields.delegation.options = delegations
        })
    },
    getSellersTypes () {
      let vm = this

      vm.getSellersTypesActive = true

      let dataToSend = ''

      api
        .sellersTypes
        .getSellersTypes(dataToSend)
        .then((response) => {
          vm.getSellersTypesActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let sellersTypes = response.data.sellersTypes

          sellersTypes = _.map(sellersTypes, (sellerType) => {
            return {
              fakeValue: sellerType.name,
              value: sellerType.id
            }
          })

          vm.formCreate.fields.sellerType.options = sellersTypes
          vm.formUpdate.fields.sellerType.options = sellersTypes
        })
    },
    exportUsers () {
      let vm = this

      let dataToSend = {
        timeZone: moment.tz.guess()
      }

      if (vm.exportUsersActive) {
        let message = {
          message: [vm.$t('private.clients.list.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      vm.exportUsersActive = true

      api
        .sellers
        .exportUsers(dataToSend)
        .then((response) => {
          vm.exportUsersActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let file = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let fileURL = URL.createObjectURL(file)

          FileSaver.saveAs(file, 'users.xlsx')
        })
    },
    resetDataMigrateUsersWindow () {
      let vm = this

      vm.migrateUsersWindow.sellersToCreated = []
      vm.migrateUsersWindow.sellersWithErrors = []
      vm.migrateUsersWindow.fields.csv.value = {}
      vm.migrateUsersWindow.fields.csv.fileReady = false
    },
    migrateUsersSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateUsersWindow.fields.separator.value,
        csv: vm.migrateUsersWindow.fields.csv.value.data
      }

      vm.migrateUsersWindow.migrateCSVFileActive = true

      api
        .sellers
        .migrateCSVFile(dataToSend)
        .then((response) => {
          vm.migrateUsersWindow.migrateCSVFileActive = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateUsersWindow.sellersToCreated = response.data.sellersToCreated
          vm.migrateUsersWindow.sellersWithErrors = response.data.sellersWithErrors
        })
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    SelectField,
    CheckboxField,
    FileField
  },
  created () {
    let vm = this

    vm.getSellers()

    vm.getDelegations()

    vm.getSellersTypes()
  }
}



// WEBPACK FOOTER //
// ./src/components/private/sellers/list/script.js